import { useMutation } from '@apollo/client';

import { log } from 'src/app/utils/logging';
import type { CreateJobMutationVariables } from 'src/graphql/generated';
import { CREATE_JOB } from 'src/graphql/job';

interface useCreatePendingJobProps {
  advertiserNation: string;
  interactionId?: string;
}

export const useCreatePendingJob = ({
  advertiserNation,
  interactionId,
}: useCreatePendingJobProps) => {
  const [createJob] = useMutation<any, CreateJobMutationVariables>(CREATE_JOB, {
    context: {
      headers: {
        site: advertiserNation,
        'interaction-id': interactionId,
      },
    },
    onError: (error) => {
      log.error(
        'useCreatePendingJob | CreateJob',
        {
          error,
          advertiserNation,
          interactionId,
        },
        true,
      );
      throw error;
    },
  });

  return createJob;
};
